module.exports = __webpack_public_path__ + "static/img/LenovoLogo-Chinese_POS-Blue-H.7f7b41aa.png";